import Vue from 'vue'
import Vuex from 'vuex'
import { userKey, urlApi, avisoErro } from '@/config/global'
import axios from 'axios'
import '@/config/loading'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        // variaveis globais
        teste: 'dados da store',
        user: null,
        isAdmContrato: false,
        flVerificaAcesso: false,
        flAcessoProduto: false,
    },
    getters: {
        // get das variaveis
        getTeste(state) {
            return state.teste;
        },

        getUser(state) {
            return state.user;
        },

        getIdContrato(state) {
            return state.autenticacao.idContrato;
        },

        getIsAdmContrato(state) {
            return state.isAdmContrato;
        }

    },
    mutations: {
        // troca valores das variaveis
        setTeste(state, payload) {
            
            state.teste = payload;
        },

        setUser(state, user) {
            state.user = user
            if (user) {
                localStorage.setItem(userKey, JSON.stringify(user))
                axios.defaults.headers.common['Authorization'] = `Bearer ${user.accessToken}`

                axios.get(`${urlApi}/Auth/GetDadosUser?dadosOrientacao=true`)
                    .then(res => {
                        if (res.data) {
                            state.flVerificaAcesso = true;
                            state.isAdmContrato = res.data.isAdmContrato;
                            state.flAcessoProduto = res.data.flAcessoProduto;
                        } else {
                            avisoErro("Erro ao carregar dados de usuário.");
                        }
                    })
                    .catch(function () {
                        avisoErro("Erro ao carregar dados de usuário.");                        
                    })
            } else {
                localStorage.removeItem(userKey)
                delete axios.defaults.headers.common['Authorization']
            }
        },

        setIsAdmContrato(state, isAdmContrato) {
            state.isAdmContrato = isAdmContrato;
        },
                
        setLoading(state, loading) {
            state.loading = loading
        },

        showLoading(state, parameters) {
            state.loading = state.loading.show(parameters);
        },

        hideLoading(state) {
            state.loading.hide();
            state.loading = Vue.$loading;
        },

    },
    actions: {
        // logicas de trocar valores
        trocaTeste({ commit }, payload) {
            setTimeout(() => {
                commit('trocaTeste', payload)
            }, 1000)
        },

        
    }
});

export default store;